<template>
  <div class="car-model-info" v-loading="loading">
    <div class="info-list">
      <div class="info-item">
        <span class="label">企业主体全称：</span>
        <span class="value">{{ formattedData.corporationName }}</span>
      </div>
      <div class="info-item">
        <span class="label">统一社会信用代码：</span>
        <span class="value">{{ formattedData.licenceNo }}</span>
      </div>
      <div class="info-item">
        <span class="label">经营状态：</span>
        <span class="value">{{ formattedData.businessStatusDesc || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">成立日期：</span>
        <span class="value">{{ formattedData.establishDate || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">登记机关：</span>
        <span class="value">{{ formattedData.registrationAuthority || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">经营范围：</span>
        <span class="value">{{ formattedData.businessScope || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">注册电话：</span>
        <span class="value">{{ formattedData.registrationMobile || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">注册地址：</span>
        <span class="value">{{ formattedData.registrationAddress || '--' }}</span>
      </div>
      <div class="info-item full-width">
        <span class="label">营业执照：</span>
        <div class="image-wrapper">
          <span class="a-hover-link" v-if="formattedData.businessLicensePic" @click="showImages">查看</span>
          <span v-else>--</span>
        </div>
      </div>
    </div>
    <div class="edit-btn" @click="handleEdit">修改工商信息</div>
    <EditDialog ref="addCarModelRef" @refreshList="refreshTable" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import EditDialog from '@/pages/organize/enterpriseEntityInfo/addAndEditDialog/index.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['refresh'])

const addCarModelRef = ref(null)

const refreshTable = () => {
  emits('refresh')
}
// 修改信息
const handleEdit = () => {
  addCarModelRef.value.openDrawer('edit', props.data.id)
}

const formattedData = computed(() => {
  const { data } = props
  return {
    ...data,
    establishDate: data.establishDate ? data.establishDate.split(' ')[0] : '',
  }
})

const showImages = () => {
  const { businessLicensePic } = formattedData.value
  if (!businessLicensePic) return
  window.open(businessLicensePic, '_blank')
}
</script>

<style lang="scss" scoped>
.car-model-info {
  padding: 12px;
  margin: 0 0 24px 100px;
  background: #f3f3f4;
  border-radius: 8px;
  opacity: 1;
  background: #f3f3f4;
  margin-top: -16px;

  .info-list {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .info-item {
      display: flex;
      align-items: flex-start;

      &.full-width {
        width: 100%;
      }

      .label {
        width: auto;
        color: #606266;
        margin-right: 4px;
        flex-shrink: 0;
        text-align: right;
      }

      .value {
        color: #303133;
        flex: 1;
        overflow: hidden;
        word-break: break-all;
        white-space: pre-wrap;
      }

      .image-wrapper {
        width: 160px;
        border-radius: 4px;
        overflow: hidden;
      }
    }
  }

  .edit-btn {
    color: #366cff;
    font-size: 14px;
    cursor: pointer;
    margin-top: 16px;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
